module.exports = __webpack_public_path__ + "static/media/006_Control_Panel_-_2014-07-17_13.14.00.065b9717.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/intel/006_Control_Panel_-_2014-07-17_13.14.00.png
// module id = 477
// module chunks = 0